export const filterEntriesByField = (entries, field, fieldValue) => {
  return entries.filter(({ node }) => {
    return node[field] !== fieldValue
  })
}

export const createBackgroundImageCSS = (entry, additionalQuerying) => {
  if (additionalQuerying == null) {
    return {
      backgroundImage: `url("${entry}")`,
    }
  } else {
    return {
      backgroundImage: `url("${entry}${additionalQuerying}")`,
    }
  }
}

export const estimateReadTime = (wordcount, totalNumberImages) => {
  const totalSecondsForWords = (wordcount / 200) * 60
  const totalSecondsForImages = totalNumberImages * 12
  return Math.round((totalSecondsForWords + totalSecondsForImages) / 60)
}

export const getDistanceFromTop = element => {
  var yPos = 0

  while (element) {
    yPos += element.offsetTop
    element = element.offsetParent
  }

  return yPos
}

export const isInViewport = (elem, offsetVertical) => {
  const bounding = elem.getBoundingClientRect()
  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <=
      (window.innerWidth || document.documentElement.clientWidth)
  )
}

export const shuffleArray = array => {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex -= 1

    // And swap it with the current element.
    temporaryValue = array[currentIndex]
    array[currentIndex] = array[randomIndex]
    array[randomIndex] = temporaryValue
  }

  return array
}

// detect if two elements touch each other
export const doElementsCollide = (el1, el2) => {
  const rect1 = el1.getBoundingClientRect()
  const rect2 = el2.getBoundingClientRect()
  // el1.offsetBottom = el1.offsetTop + el1.offsetHeight
  // el1.offsetRight = el1.offsetLeft + el1.offsetWidth
  // el2.offsetBottom = el2.offsetTop + el2.offsetHeight
  // el2.offsetRight = el2.offsetLeft + el2.offsetWidth

  return !(
    rect1.right < rect2.left ||
    rect1.left > rect2.right ||
    rect1.bottom < rect2.top ||
    rect1.top > rect2.bottom
  )
}

// remove duplicates from an array of objects
// based on an object key (comp)
export const getUnique = (arr, comp) => {
  const unique = arr
    .map(e => e[comp])

    // store the keys of the unique objects
    .map((e, i, final) => final.indexOf(e) === i && i)

    // eliminate the dead keys & store unique objects
    .filter(e => arr[e])
    .map(e => arr[e])

  return unique
}
